import { EMPTY_ARRAY, GUID } from "@faro-lotv/foundation";
import {
  CaptureTreeEntityRevision,
  isSiteScapeClusterEntity,
} from "@faro-lotv/service-wires";
import { createSelector } from "@reduxjs/toolkit";
import {
  selectRevisionEntities,
  selectRevisionEntityChildrenMap,
} from "./revision-entity-selectors";

/**
 * @param state The current application state.
 * @returns All clusters where the scans should be treated as one unit in the revision.
 */
export const selectRevisionAtomicClusters = createSelector(
  [selectRevisionEntities],
  (revisionEntities) => revisionEntities.filter(isSiteScapeClusterEntity),
);

/**
 * @param state The current application state.
 * @returns All cluster ids of atomic clusters in the revision.
 */
export const selectRevisionAtomicClusterIds = createSelector(
  [selectRevisionAtomicClusters],
  (siteScapeClusterEntities) =>
    siteScapeClusterEntities.map((cluster) => cluster.id),
);

export type AtomicClusterMap = Map<GUID, CaptureTreeEntityRevision>;

/**
 * @param state The current application state.
 * @returns A map from scan IDs to their corresponding atomic cluster, if they are part of one.
 */
export const selectScansToAtomicClusterMap = createSelector(
  [selectRevisionAtomicClusters, selectRevisionEntityChildrenMap],
  (atomicClusters, childrenMap): AtomicClusterMap => {
    const map = new Map();

    for (const atomicCluster of atomicClusters) {
      const children = childrenMap[atomicCluster.id] ?? EMPTY_ARRAY;

      for (const child of children) {
        map.set(child.id, atomicCluster);
      }
    }

    return map;
  },
);
